import { ERefundType } from "@frameworks/NCD/Enum/OTC";
export var useRefundFormDescription = function (RefundType) {
    var label = "";
    var excessFundTypes = [ERefundType.ExcessFunds, 1, 6, 11, 16];
    var interestDividendTypes = [ERefundType.InterestDividend, 2, 7, 13];
    var cancelledRejectedTypes = [ERefundType.CancelledRejected, 3, 9, 14, 19];
    var suspenseTypes = [ERefundType.Suspense];
    if (excessFundTypes.includes(RefundType)) {
        label =
            "Use when client has paid excess amount compared to the actual order value executed";
    }
    else if (interestDividendTypes.includes(RefundType) ||
        cancelledRejectedTypes.includes(RefundType)) {
        label = "When order could not go through despite client making payment";
    }
    else if (suspenseTypes.includes(RefundType)) {
        label =
            "When payment is made from someone else’s account (e.g., spouse, friend, or relative).";
    }
    else {
        label = "";
    }
    return label;
};
